import React, { useState, useEffect, useMemo, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import Select from "react-select";
import swal from "sweetalert";
import { Button, Modal } from "react-bootstrap";
import validator from "validator"; //https://www.npmjs.com/package/validator
// import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import PageTitle from "../../layouts/PageTitle";
import Table from "../../components/table/ReactTable/Table";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { Badge } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { masterActions, vendorActions } from "../../../_store";
import { Link } from "react-router-dom";
import Toastr from "../../components/common/Toastr";
import generatePDF from "../../components/export/generatePDF";
import generateXlsx from "../../components/export/generateXlsx";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import CommonService from "../../../services/Common/CommonService";

const VendorList = () => {
  const COLUMNS = [
    {
      Header: "First Name",
      Footer: "First Name",
      accessor: "FirstName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Last Name",
      Footer: "Last Name",
      accessor: "LastName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Contact Number",
      Footer: "Contact Number",
      accessor: "ContactNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Email Id",
      Footer: "Email Id",
      accessor: "EmailID",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Billing City",
      Footer: "Billing City",
      accessor: "BillingCity",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Billing State",
      Footer: "Billing State",
      accessor: "BillingStateName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Created Date",
      Footer: "Created Date",
      accessor: "CreatedDateString",
      justify: "left",
      fieldType: "Date",
      //  Cell: ({ value }) => { return format(new Date(value), 'MM/dd/yyyy') },
      Filter: ColumnFilter,
    },
    {
      Header: "Status",
      Footer: "Status",
      accessor: "StatusName",
      justify: "center",
      Cell: ({ value }) => {
        return (
          <>
            <Badge variant="primary light badge-lg"> {value}</Badge>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "",
      Footer: "",
      accessor: "VendorID",
      disableFilters: true,
      Cell: ({ value }) => {
        return (
          <>
            <div className="d-flex">
              <Link
                onClick={() => handleEditClick(value)}
                className="btn btn-primary shadow btn-xs sharp me-1"
                title="Edit"
              >
                <i className="fas fa-pen"></i>
              </Link>
              <Link
                onClick={() => handleDeleteClick(value)}
                className="btn btn-danger shadow btn-xs sharp"
                title="Delete"
              >
                <i className="fa fa-trash"></i>
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  const columns = useMemo(() => COLUMNS, []);

  const generateColumns = [
    {
      header: "First Name",
      dataKey: "FirstName",
    },
    {
      header: "Last Name",
      dataKey: "LastName",
    },
    {
      header: "Contact Number",
      dataKey: "ContactNumber",
    },
    {
      header: "Email Id",
      dataKey: "EmailID",
    },
    {
      header: "Billing City",
      dataKey: "BillingCity",
    },
    {
      header: "Billing State",
      dataKey: "BillingStateName",
    },
    {
      header: "Created Date",
      dataKey: "CreatedDateString",
    },
    {
      header: "Status",
      dataKey: "StatusName",
    },
  ];

  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const currentUser = useSelector((x) => x.auth.user);
  const vendor = useSelector((x) => x.vendor.vendor);
  const vendorList = useSelector((x) => x.vendor.vendorList);
  const vendorResponse = useSelector((x) => x.vendor.vendorResponse);
  const stateDrpList = useSelector((x) => x.master.stateDrpList);
  const countryDrpList = useSelector((x) => x.master.countryDrpList);
  const deletevendorResponse = useSelector(
    (x) => x.vendor.deletevendorResponse
  );

  const [isOpenModal, setOpenModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const isLoading = useSelector((x) => x.vendor.isLoading);
  const [stateList, setStateList] = useState([]);
  const [finalTableData, setFinalTableData] = useState([]);
  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);

  useEffect(() => {
    showLoader();
    dispatch(masterActions.GetStateList());
    dispatch(masterActions.GetCountryList());
    dispatch(vendorActions.getVendorAll());
  }, [dispatch]);
  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);
  //Add State
  const [addFormData, setAddFormData] = useState({
    VendorID: 0,
    FirstName: "",
    LastName: "",
    CompanyName: "",
    ContactNumber: "",
    EmailID: "",
    BillingAddress: "",
    BillingCountryID: 0,
    BillingStateID: 0,
    BillingCity: "",
    BillingZipCode: "",
    ShippingAddress: "",
    ShippingCountryID: 0,
    ShippingStateID: 0,
    ShippingCity: "",
    ShippingZipCode: "",
    StatusName: "",
    BillingCountryName: "",
    BillingStateName: "",
    ShippingStateName: "",
    ShippingCountryName: "",
    IsShippingSame: false,
    IsContactNumber: true,
    IsBillingZipCode: true,
    IsShippingZipCode: true,
    IsEmailIDValid: true,
    IsContactNumberValid: true,
    SCountryOptions: true,
    CountryOption: true,
    BCountryOption: true,
    Extension: "",
    CountryCode: "",
    Status: 1,
    CreatedBy: currentUser.Id,
  });
  const newFormData = { ...addFormData };

  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  // handle Change function
  const handleChange = (event) => {
    event.preventDefault();
    const regexString = /^[a-zA-Z\s]*$/;
    const regexNumber = /^[0-9\b\s()-]+$/;
    const regexExtensionNumber = /^[0-9\b\s]+$/;
    const IsRegexNumber = /^\((\d{3})\)[ ](\d{3})[-](\d{4})$/;

    const nospecial = /^[a-zA-Z0-9]+$/;
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    const newFormData = { ...addFormData };
    const CountryList = [...countryDrpList];

    if (fieldValue && fieldValue.trim()) {
      if (
        fieldName === "FirstName" ||
        fieldName === "LastName" ||
        fieldName === "CompanyName" ||
        fieldName === "BillingCity" ||
        fieldName === "ShippingCity"
      ) {
        if (fieldValue === "" || regexString.test(fieldValue))
          newFormData[fieldName] = fieldValue;
      } else if (fieldName === "ContactNumber" && fieldValue) {
        if (fieldValue === "" || regexNumber.test(fieldValue)) {
          newFormData[fieldName] = fieldValue;
        }
      } else if (fieldName === "Extension") {
        if (fieldValue === "" || regexExtensionNumber.test(fieldValue)) {
          newFormData[fieldName] = fieldValue.replace(/\s/g, "");
        }
      } else if (fieldName === "BillingZipCode") {
        let CountryRow = CountryList.find(
          (d) => d.value === newFormData.BCountryOption.value
        );
        let ZipCodeLimit;
        try {
          ZipCodeLimit = parseFloat(fieldValue.replace(/\$|,/g, ""));
        } catch {
          ZipCodeLimit = fieldValue;
        }
        ZipCodeLimit = ZipCodeLimit.toString();
        if (CountryRow.value === 233) {
          if (
            fieldValue === "" ||
            (regexNumber.test(fieldValue) && ZipCodeLimit.length <= 5)
          ) {
            newFormData[fieldName] = fieldValue;
          }
        } else {
          if (
            fieldValue === "" ||
            (nospecial.test(fieldValue) && ZipCodeLimit.length <= 6)
          )
            newFormData[fieldName] = fieldValue;
        }
      } else if (fieldName === "ShippingZipCode") {
        let CountryRow = CountryList.find(
          (d) => d.value === newFormData.SCountryOptions.value
        );
        let ZipCodeLimit;
        try {
          ZipCodeLimit = parseFloat(fieldValue.replace(/\$|,/g, ""));
        } catch {
          ZipCodeLimit = fieldValue;
        }
        ZipCodeLimit = ZipCodeLimit.toString();
        if (CountryRow.value === 233) {
          if (
            fieldValue === "" ||
            (regexNumber.test(fieldValue) && ZipCodeLimit.length <= 5)
          ) {
            newFormData[fieldName] = fieldValue;
          }
        } else {
          if (
            fieldValue === "" ||
            (nospecial.test(fieldValue) && ZipCodeLimit.length <= 6)
          )
            newFormData[fieldName] = fieldValue;
        }
      } else {
        newFormData[fieldName] = fieldValue;
      }
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }

    if (fieldName === "EmailID" && fieldValue) {
      newFormData.IsEmailIDValid = validator.isEmail(fieldValue);
    }
    if (fieldName === "ContactNumber" && fieldValue) {
      newFormData.IsContactNumberValid = !!IsRegexNumber.test(fieldValue);
    }
    // if (fieldName === "BillingZipCode" && fieldValue) {
    //     newFormData.IsBillingZipCode = validator.isPostalCode(fieldValue.toString(), 'US')
    // }

    // if (fieldName === "ShippingZipCode" && fieldValue) {
    //     newFormData.IsShippingZipCode = validator.isPostalCode(fieldValue.toString(), 'US')
    // }
    if (
      fieldName === "BillingAddress" ||
      fieldName === "BillingCity" ||
      fieldName === "BillingZipCode"
    ) {
      newFormData.IsShippingSame = false;
    }

    setAddFormData(newFormData);
  };

  //
  const chkSameAddress = (event) => {
    if (event.target.checked === true) {
      newFormData.IsShippingSame = true;
      newFormData.ShippingAddress = addFormData.BillingAddress;
      newFormData.ShippingCity = addFormData.BillingCity;
      newFormData.ShippingZipCode = addFormData.BillingZipCode;
      newFormData.ShippingCountryID = addFormData.BillingCountryID;
      newFormData.ShippingStateID = addFormData.BillingStateID;
      newFormData.ShipStateOption = addFormData.BillStateOption;
      newFormData.SCountryOptions = addFormData.BCountryOption;

      // newFormData.ShipStateOption = {
      //     value: addFormData.BillStateOption.value, label: addFormData.BillStateOption.label
      // }
      // newFormData.SCountryOptions = {
      //     value: addFormData.BCountryOption.value, label: addFormData.BCountryOption.label
      // }

      setAddFormData(newFormData);
    } else if (event.target.checked === false) {
      newFormData.IsShippingSame = false;
      newFormData.ShippingAddress = "";
      newFormData.ShippingCity = "";
      newFormData.ShippingZipCode = "";

      newFormData.ShipStateOption = null;
      newFormData.SCountryOptions = null;

      setAddFormData(newFormData);
    }
  };

  // handle Dropdown Change function
  const handleDrpChange = (event, title) => {
    // const newFormData = { ...addFormData };
    newFormData[title] = event.value && parseInt(event.value);

    // if (title === "BillingStateID") {
    //     newFormData.BillStateOption = {
    //         value: parseInt(event.value), label: event.label
    //     }

    // }
    // if (title === "ShippingStateID") {

    //     newFormData.ShipStateOption = {
    //         value: parseInt(event.value), label: event.label
    //     }

    // }
    if (title === "BillingCountryID") {
      newFormData.BCountryOption = {
        value: parseInt(event.value),
        label: event.label,
      };
      if (event.value && parseInt(event.value) > 0) {
        let stateList = [...stateDrpList];
        stateList = stateList.filter(
          (d) => d.parentId === parseInt(event.value)
        );
        setStateList(stateList);
        newFormData.BillStateOption = null;
        newFormData.CountryCode = event.parentId;
      }
      if (event.value && parseInt(event.value) !== 233) {
        newFormData.BillingZipCode = "";
      }
      if (event.value && parseInt(event.value) === 233) {
        newFormData.BillingZipCode = "";
      }
    } else if (title === "BillingStateID") {
      newFormData.BillStateOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "ShippingCountryID") {
      newFormData.SCountryOptions = {
        value: parseInt(event.value),
        label: event.label,
      };
      if (event.value && parseInt(event.value) > 0) {
        let stateList = [...stateDrpList];
        stateList = stateList.filter(
          (d) => d.parentId === parseInt(event.value)
        );
        setStateList(stateList);
        newFormData.ShipStateOption = null;
      }
      if (event.value && parseInt(event.value) !== 233) {
        newFormData.ShippingZipCode = "";
      }
      if (event.value && parseInt(event.value) === 233) {
        newFormData.ShippingZipCode = "";
      }
    } else if (title === "ShippingStateID") {
      newFormData.ShipStateOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    }
    if (title === "BillingStateID" || title === "BillingCountryID") {
      newFormData.IsShippingSame = false;
    }
    setAddFormData(newFormData);
  };

  // Submit data function
  const handleSubmit = (event) => {
    event.preventDefault();
    var error = false;
    if (
      !addFormData.FirstName ||
      !addFormData.EmailID ||
      !addFormData.ContactNumber ||
      !addFormData.CompanyName ||
      !addFormData.BillingCity ||
      !addFormData.BillingZipCode ||
      !addFormData.BillingAddress ||
      !addFormData.ShippingAddress ||
      !addFormData.ShippingCity ||
      !addFormData.BillingCountryID ||
      addFormData.BillingCountryID === 0 ||
      addFormData.ShippingCountryID === 0 ||
      !addFormData.ShippingCountryID ||
      !addFormData.BillingStateID ||
      addFormData.BillingStateID === 0 ||
      addFormData.ShippingStateID === 0 ||
      !addFormData.ShippingStateID ||
      addFormData.IsContactNumberValid === false ||
      !addFormData.ShippingZipCode ||
      addFormData.BillStateOption === null ||
      addFormData.ShipStateOption === null
    ) {
      error = true;
    }
    let alertMsg;
    // if (addFormData.ContactNumber.length < 15) {
    //     alertMsg = 'Please fill in the contact number in valid format';
    // }
    if (addFormData.IsContactNumberValid === false) {
      alertMsg = "Please fill in the ContactNumber in valid form";
    }

    if (
      addFormData.IsEmailIDValid === false ||
      addFormData.IsShippingZipCode === false ||
      addFormData.IsBillingZipCode === false ||
      addFormData.BillingZipCode.length < 3 ||
      addFormData.ShippingZipCode.length < 3
    ) {
      error = true;
      alertMsg = "Please fill in the data in valid format";
    }
    if (
      !addFormData.FirstName ||
      !addFormData.EmailID ||
      !addFormData.CompanyName ||
      !addFormData.BillingAddress ||
      !addFormData.ContactNumber ||
      !addFormData.BillingCity ||
      !addFormData.ShippingCity ||
      !addFormData.ShippingAddress ||
      !addFormData.BillingZipCode ||
      addFormData.BillStateOption === null ||
      !addFormData.ShippingZipCode ||
      addFormData.ShipStateOption === null
    ) {
      alertMsg = "Please fill in the required missing fields";
    }

    if (!error) {
      dispatch(vendorActions.saveVendor(newFormData));
    } else {
      setSubmitted(true);
      // alertMsg="Missing";
      alertMsg && Toastr(`${alertMsg}`, "warning");
    }
  };
  // handle Check Box Click function
  const handleCkBoxChange = (event, title) => {
    let hasChecked = event.target.checked === true ? 1 : 2;
    if (
      !event.target.checked &&
      newFormData.VendorID &&
      newFormData.VendorID > 0
    ) {
      showLoader();

      let Param = { DeleteID: newFormData.VendorID, DeleteType: 7 };
      CommonService.CheckMappedItem(Param).then((res) => {
        if (res.data === 1) {
          newFormData[title] = hasChecked;
          setAddFormData(newFormData);
          hideLoader();
        } else {
          Toastr("This Vender is already mapped", "warning");
          hideLoader();
        }
      });
    } else {
      newFormData[title] = hasChecked;
      setAddFormData(newFormData);
    }
  };

  const handlePoupClick = () => {
    newFormData.VendorID =
      newFormData.ShippingCountryID =
      newFormData.BillingCountryID =
        0;
    newFormData.BillingAddress =
      newFormData.BillingCity =
      newFormData.BillingCountryID =
      newFormData.BillingStateID =
      newFormData.BillingZipCode =
      newFormData.CompanyName =
      newFormData.ContactNumber =
      newFormData.FirstName =
      newFormData.LastName =
      newFormData.ShippingAddress =
      newFormData.ShippingCity =
      newFormData.ShippingCountryID =
      newFormData.ShippingStateID =
      newFormData.ShippingZipCode =
      newFormData.Extension =
      newFormData.CountryCode =
        "";
    // newFormData.CountryOption = null;
    // newFormData.BillingStateID = null;
    newFormData.Status = 1;
    newFormData.SCountryOptions = null;
    newFormData.BCountryOption = null;
    newFormData.BillStateOption = null;
    newFormData.ShipStateOption = null;
    newFormData.EmailID = null;
    newFormData.IsContactNumberValid = true;
    newFormData.IsEmailIDValid = true;
    newFormData.IsBillingZipCode = true;
    newFormData.IsShippingZipCode = true;
    newFormData.IsShippingSame = false;
    setAddFormData(newFormData);
    setOpenModal(true);
    setSubmitted(false);
    setStateList([]);
  };
  const handleEditClick = (Id) => {
    dispatch(vendorActions.getVendorById({ VendorID: Id }));
    setOpenModal(true);
    setSubmitted(false);
  };

  const handleDeleteClick = (Id) => {
    swal({
      title: "Are you sure, you want to delete this Vendor?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        let Param = { DeleteID: Id, DeleteType: 7 };
        CommonService.CheckMappedItem(Param).then((response) => {
          if (response.data === 1) {
            dispatch(
              vendorActions.deleteVendor({
                VendorID: Id,
                DeletedBy: currentUser.Id,
              })
            );
          } else {
            Toastr("This Vendor is already mapped", "warning");
            hideLoader();
          }
        });
      }
    });
  };
  // handleDeleteClick
  useEffect(() => {
    if (deletevendorResponse === 1) {
      Toastr("Vendor details deleted successfully", "success");
      dispatch(vendorActions.getVendorAll());
    } else if (deletevendorResponse === -1) {
      Toastr("Error ", "warning");
    }
  }, [deletevendorResponse]);
  // Vendor Add And Update
  useEffect(() => {
    if (vendorResponse === 1) {
      Toastr("Vendor details added successfully", "success");
      dispatch(vendorActions.getVendorAll({ CurrentUserID: currentUser.Id }));
      newFormData.VendorID = newFormData.StateID = 0;

      setOpenModal(false);
      setAddFormData(newFormData);
    } else if (vendorResponse === 2) {
      Toastr("Vendor details updated Successfully", "success");
      dispatch(vendorActions.getVendorAll({ CurrentUserID: currentUser.Id }));
      setOpenModal(false);
      setAddFormData(newFormData);
    } else if (vendorResponse === -1) {
      Toastr("Email id already exists ", "warning");
    }
  }, [vendorResponse]);
  // Edit Vendor
  useEffect(() => {
    if (vendor && vendor.VendorID > 0) {
      newFormData.VendorID = vendor.VendorID;
      newFormData.BillingAddress = vendor.BillingAddress;
      newFormData.BillingCity = vendor.BillingCity;
      newFormData.BillingCountryID = vendor.BillingCountryID;
      newFormData.BillingCountryName = vendor.BillingCountryName;
      newFormData.BillingStateID = vendor.BillingStateID;
      newFormData.BillingZipCode = vendor.BillingZipCode;
      newFormData.BillingStateName = vendor.BillingStateName;
      newFormData.CompanyName = vendor.CompanyName;
      newFormData.ContactNumber = vendor.ContactNumber;
      newFormData.EmailID = vendor.EmailID;
      newFormData.FirstName = vendor.FirstName;
      newFormData.LastName = vendor.LastName;
      newFormData.ShippingAddress = vendor.ShippingAddress;
      newFormData.ShippingCity = vendor.ShippingCity;
      newFormData.ShippingCountryID = vendor.ShippingCountryID;
      newFormData.ShippingStateID = vendor.ShippingStateID;
      newFormData.ShippingZipCode = vendor.ShippingZipCode;
      newFormData.ShippingStateName = vendor.ShippingStateName;
      newFormData.Status = vendor.Status;
      newFormData.Extension = vendor.Extension;
      newFormData.IsShippingSame = vendor.IsShippingSame;
      newFormData.BillStateOption = {
        value: vendor.BillingStateID,
        label: vendor.BillingStateName,
      };
      newFormData.ShipStateOption = {
        value: vendor.ShippingStateID,
        label: vendor.ShippingStateName,
      };
      newFormData.SCountryOptions = {
        value: vendor.ShippingCountryID,
        label: vendor.ShippingCountryName,
      };
      newFormData.BCountryOption = {
        value: vendor.BillingCountryID,
        label: vendor.BillingCountryName,
      };
      let stateList = [...stateDrpList];
      stateList = stateList.filter(
        (d) => d.parentId === parseInt(vendor.BillingCountryID)
      );
      setStateList(stateList);
      newFormData.IsContactNumberValid = true;
      newFormData.IsEmailIDValid = true;
      newFormData.IsBillingZipCode = true;
      newFormData.IsShippingZipCode = true;
      let CountryCode = [...countryDrpList];
      CountryCode = CountryCode.filter(
        (d) => d.value === vendor.BillingCountryID
      );

      newFormData.CountryCode = CountryCode[0].parentId;
      //newFormData.IsShippingSame = false;
      setAddFormData(newFormData);
    }
  }, [vendor]);
  ///  export  //
  const handleClickPDF = () => {
    let title = "Vendor List";
    const columnStyles = {
      FirstName: { halign: "left", cellWidth: 30 },
      LastName: { halign: "left", cellWidth: 30 },
      ContactNumber: { halign: "center", cellWidth: 40 },
      EmailID: { halign: "left", cellWidth: 40 },
      BillingCity: { halign: "left", cellWidth: 30 },
      BillingStateName: { halign: "left", cellWidth: 40 },
      CreatedDateString: { halign: "left", cellWidth: 30 },
      StatusName: { halign: "center", cellWidth: 40 },
    };

    generatePDF(finalTableData, generateColumns, true, title, columnStyles);
  };
  const handleClickExcel = () => {
    let title = "Vendor";
    let generateExcelColumns = [
      "First Name",
      "Last Name",
      "Contact Number",
      "Email Id",
      "Billing City",
      "Billing State",
      "Created Date",
      "Status",
    ];
    let new_VendorList =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          FirstName: obj.FirstName,
          LastName: obj.LastName,
          ContactNumber: obj.ContactNumber,
          EmailID: obj.EmailID,
          BillingCity: obj.BillingCity,
          BillingStateName: obj.BillingStateName,
          CreatedDateString: obj.CreatedDateString,
          StatusName: obj.StatusName,
        };
      });

    generateXlsx(new_VendorList, generateExcelColumns, title);
  };

  return (
    <>
      <PageTitle activeMenu="Manage Vendor" motherMenu="Users" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Vendor List</h4>
          <div className="float-sm-end">
            {vendorList && vendorList.length > 0 && (
              <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                    {/* <i className="fa fa-regular fa-file-excel"></i> */}
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
              </>
            )}
            <Button
              className="me-2"
              variant="primary btn-rounded"
              onClick={handlePoupClick}
            >
              <span className="btn-icon-start text-primary">
                <i className="fa fa-plus color-info" />
              </span>
              Add
            </Button>
          </div>
        </div>
        <div className="card-body">
          <Table
            columns={columns}
            data={vendorList}
            onDataUpdate={handleTableDataUpdate}
          />
        </div>
      </div>
      {/* <!-- Modal --> */}
      <Modal className="fade bd-example-modal-lg" show={isOpenModal} size="lg">
        <Modal.Header>
          <Modal.Title>
            {newFormData.VendorID > 0 ? "Edit Vendor" : "Add Vendor"}
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setOpenModal(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  First Name<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted && !addFormData.FirstName && "border-danger"
                    }`}
                    autocomplete="off"
                    name="FirstName"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.FirstName}
                    placeholder="First Name"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">Last Name</label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${addFormData.LastName}`}
                    autocomplete="off"
                    name="LastName"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.LastName}
                    placeholder="Last Name"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Company Name<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted && !addFormData.CompanyName && "border-danger"
                    }`}
                    autocomplete="off"
                    name="CompanyName"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.CompanyName}
                    placeholder="Company Name"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Email ID<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      newFormData.VendorID > 0 ? "readonly_css" : ""
                    } ${submitted && !addFormData.EmailID && "border-danger"}`}
                    autocomplete="off"
                    name="EmailID"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.EmailID}
                    placeholder="Email ID"
                    maxLength={50}
                    readOnly={newFormData.VendorID > 0 ? true : false}
                  />
                  <span className="validation-text text-danger">
                    {!newFormData.IsEmailIDValid &&
                      "Please enter valid Email Id"}
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Contact Number<span className="text-danger">*</span>
                </label>
                <div className="input-group mb-2">
                  <div className="input-group-text">
                    +{newFormData.CountryCode}
                  </div>
                  <input
                    type="text"
                    className={`form-control ${
                      submitted &&
                      (!addFormData.ContactNumber ||
                        addFormData.ContactNumber.length < 14) &&
                      "border-danger"
                    }`}
                    autocomplete="off"
                    name="ContactNumber"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.ContactNumber}
                    maxLength={14}
                    placeholder="(XXX) XXX-XXXX"
                  />
                  <span className="validation-text text-danger">
                    {!newFormData.IsContactNumberValid &&
                      "Please enter valid Contact Number eg.(XXX) XXX-XXXX"}
                  </span>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">Extension</label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${addFormData.Extension}`}
                    autocomplete="off"
                    name="Extension"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.Extension}
                    maxLength={6}
                    placeholder="Extension"
                  />
                </div>
              </div>
              <div className="col-md-12 mb-4">
                <div className="contact-name">
                  <label className="text-black font-w500">
                    Billing Address<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      submitted &&
                      !addFormData.BillingAddress &&
                      "border-danger"
                    }`}
                    autocomplete="off"
                    name="BillingAddress"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.BillingAddress}
                    placeholder="Billing Address"
                    maxLength={300}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Country<span className="text-danger">*</span>
                </label>
                <Select
                  classNamePrefix={"custom_select_css"}
                  name="BillingCountryID"
                  value={newFormData.BCountryOption}
                  onChange={(event) =>
                    handleDrpChange(event, "BillingCountryID")
                  }
                  options={countryDrpList}
                  styles={
                    submitted &&
                    (!newFormData.BillingCountryID ||
                      newFormData.BillingCountryID === 0)
                      ? styles
                      : ""
                  }
                />
                <span className="validation-text"></span>
              </div>
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  State<span className="text-danger">*</span>
                </label>
                <Select
                  classNamePrefix={"custom_select_css"}
                  name="BillingStateID"
                  value={newFormData.BillStateOption}
                  onChange={(event) => handleDrpChange(event, "BillingStateID")}
                  options={stateList}
                  // styles={submitted && newFormData.BillingStateID === 0 ? styles : ''}
                  styles={
                    submitted &&
                    (!newFormData.BillingStateID ||
                      newFormData.BillingStateID === 0 ||
                      newFormData.BillStateOption === null)
                      ? styles
                      : ""
                  }
                />
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  City<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    submitted && !addFormData.BillingCity && "border-danger"
                  }`}
                  autocomplete="off"
                  name="BillingCity"
                  required="required"
                  onChange={handleChange}
                  value={newFormData.BillingCity}
                  placeholder="City"
                  maxLength={50}
                />
                <span className="validation-text"></span>
              </div>
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Zip Code<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    submitted &&
                    (!addFormData.BillingZipCode ||
                      addFormData.BillingZipCode.length < 3) &&
                    "border-danger"
                  }`}
                  autocomplete="off"
                  name="BillingZipCode"
                  required="required"
                  onChange={handleChange}
                  value={newFormData.BillingZipCode}
                  placeholder="Zip Code"
                  maxLength={6}
                />
                <span className="validation-text text-danger">
                  {!newFormData.IsBillingZipCode &&
                    "Please enter valid Zip Code"}
                </span>
              </div>
            </div>

            <div className="form-check custom-checkbox mb-4">
              <input
                type="checkbox"
                name="checkMe"
                className="form-check-input"
                checked={newFormData.IsShippingSame}
                id="customCheckBox1"
                onChange={chkSameAddress}
                required
              />
              <label className="form-check-label" htmlFor="customCheckBox1">
                Same as the above
              </label>
            </div>

            <div className="row">
              <div className="col-md-12 mb-4">
                <label className="text-black font-w500">
                  Shipping Address<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    newFormData.IsShippingSame ? "readonly_css" : ""
                  } ${
                    submitted && !addFormData.ShippingAddress && "border-danger"
                  }`}
                  autocomplete="off"
                  name="ShippingAddress"
                  required="required"
                  onChange={handleChange}
                  readOnly={newFormData.IsShippingSame}
                  value={newFormData.ShippingAddress}
                  placeholder="Shipping Address"
                  maxLength={300}
                />
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Country<span className="text-danger">*</span>
                </label>
                <Select
                  classNamePrefix={"custom_select_css"}
                  name="ShippingCountryID"
                  value={newFormData.SCountryOptions}
                  onChange={(event) =>
                    handleDrpChange(event, "ShippingCountryID")
                  }
                  options={countryDrpList}
                  isDisabled={newFormData.IsShippingSame}
                  styles={
                    submitted &&
                    (!newFormData.ShippingCountryID ||
                      newFormData.ShippingCountryID === 0 ||
                      newFormData.SCountryOptions === null)
                      ? styles
                      : ""
                  }
                />
                <span className="validation-text"></span>
              </div>
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  State<span className="text-danger">*</span>
                </label>
                <Select
                  classNamePrefix={"custom_select_css"}
                  name="ShippingStateID"
                  //defaultValue={Usertype}
                  value={newFormData.ShipStateOption}
                  onChange={(event) =>
                    handleDrpChange(event, "ShippingStateID")
                  }
                  options={stateList}
                  isDisabled={newFormData.IsShippingSame}
                  styles={
                    submitted &&
                    (!newFormData.ShippingStateID ||
                      newFormData.ShippingStateID === 0 ||
                      newFormData.ShipStateOption === null)
                      ? styles
                      : ""
                  }
                />
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  City<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    newFormData.IsShippingSame ? "readonly_css" : ""
                  } ${
                    submitted && !addFormData.ShippingCity && "border-danger"
                  }`}
                  autocomplete="off"
                  name="ShippingCity"
                  required="required"
                  onChange={handleChange}
                  readOnly={newFormData.IsShippingSame}
                  value={newFormData.ShippingCity}
                  placeholder="City"
                  maxLength={50}
                />
                <span className="validation-text"></span>
              </div>
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Zip Code<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    newFormData.IsShippingSame ? "readonly_css" : ""
                  } ${
                    submitted &&
                    (!addFormData.ShippingZipCode ||
                      addFormData.ShippingZipCode.length < 3) &&
                    "border-danger"
                  }`}
                  autocomplete="off"
                  name="ShippingZipCode"
                  required="required"
                  onChange={handleChange}
                  disabled={disabled}
                  value={newFormData.ShippingZipCode}
                  placeholder="Zip Code"
                  maxLength={6}
                />
                {/* <span className="validation-text"></span>      */}
                <span className="validation-text text-danger">
                  {!newFormData.IsShippingZipCode &&
                    "Please enter valid Zip Code"}
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-5">
                <label className="text-black font-w500">Active</label>
                <div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      name="Status"
                      checked={newFormData.Status === 1 ? true : false}
                      onChange={(event) => handleCkBoxChange(event, "Status")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger light" onClick={() => setOpenModal(false)}>
            Close
          </Button>
          <Button
            variant=""
            // onClick={() => setLargeModal(false)}
            onClick={handleSubmit}
            className="btn btn-primary"
          >
            {newFormData.VendorID > 0 ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>

      {loader}
    </>
  );
};

export default VendorList;
